import { domAnimation, LazyMotion } from 'framer-motion';
import { times, uniqueId } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';

import * as S from './InfiniteSlider.styles';

export interface InfiniteSliderProps {
  duration?: number;
  children: React.ReactNode;
}

const InfiniteSlider: React.FunctionComponent<InfiniteSliderProps> = ({
  children,
  duration,
  ...rest
}) => {
  // Default fonts are the first that loaded, it makes ref return bounding rect with wrong values on the first render.
  const [ready, setReady] = useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const emptySpace = useRef<HTMLDivElement>(null);

  const [elements, setElements] = useState(1);

  useEffect(() => {
    const availableWidth = emptySpace.current.getBoundingClientRect().width;

    if (availableWidth > 0) setElements(i => i + 1);
    else setReady(true);
  }, [elements]);

  return (
    <S.InfiniteSliderWrapper ref={wrapperRef} {...rest}>
      <LazyMotion features={domAnimation} key={uniqueId()}>
        <S.InfiniteSliderInner
          transition={{ repeat: Infinity, duration, ease: 'linear' }}
          animate={{ x: '-50%' }}
        >
          <S.ContentLine>
            {times(elements, () => (
              <S.ContentWrapper key={uniqueId()}>{children}</S.ContentWrapper>
            ))}
          </S.ContentLine>

          {ready && (
            <S.ContentLine>
              {times(elements, () => (
                <S.ContentWrapper key={uniqueId()}>{children}</S.ContentWrapper>
              ))}
            </S.ContentLine>
          )}
        </S.InfiniteSliderInner>
      </LazyMotion>

      {!ready && <S.EmptySpace ref={emptySpace} />}
    </S.InfiniteSliderWrapper>
  );
};

InfiniteSlider.defaultProps = {
  duration: 20,
};

export default InfiniteSlider;
